export const personTypes = {
  PHYSICAL: 'PHYSICAL',
  LEGAL: 'LEGAL',
}
